export default __webpack_public_path__ + "static/media/image__.bbcf3230.png";